module.exports = __webpack_public_path__ + "static/banner1-96199963430a92bf5c15349943ec90aa.gif";